import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TabViewModule } from "@bfx/primeng/tabview";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { MenuModule } from "@bfx/primeng/menu";
import { ButtonModule } from "@bfx/primeng/button";

import { BfxDetailFillComponent } from "./bfx-detail-fill.component";
import { BfxDetailFillGridComponent } from "./bfx-detail-fill-grid.component";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { BfxDetailFillService } from "./services/bfx-detail-fill.service";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { DealtPricingService } from "shared/cubiq-services/lookup/pricing/impl/DealtPricingService";
import { BfxDetailFillEditorsModule } from "./bfx-detail-fill-editors.module";
import { SplitButtonModule } from "@bfx/primeng/splitbutton";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    BfxSharedModule,
    CommonModule,
    TranslateModule,
    BfxElementsLibraryModule,
    TabViewModule,
    AgGridModule,
    MenuModule,
    CheckboxModule,
    FormsModule,
    ButtonModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    BfxDetailFillEditorsModule,
    SplitButtonModule,
    BaseComponentsModule,
  ],
  declarations: [BfxDetailFillComponent, BfxDetailFillGridComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxDetailFillService,
    DealtPricingService,
  ],
  exports: [BfxDetailFillComponent, BfxDetailFillGridComponent],
  bootstrap: [BfxDetailFillComponent, BfxDetailFillGridComponent],
})
export class BfxDetailFillModule {}
